/**
 * Exportação da lista de Clientes (PDF, Excel, CSV, imagem) e snapshot do
 * agendador, com o mesmo id "clientes" da tela anterior: exportações
 * agendadas seguem funcionando. Exporta sempre todas as linhas filtradas.
 */
import { ROTULO_DA_ESPERA, ROTULO_DA_FAIXA } from "../dados/regras";

function colunas(comCentral) {
  return [
    { key: "saude", label: "Saúde (%)", type: "number" },
    { key: "faixa", label: "Faixa", type: "text" },
    { key: "nome", label: "Cliente", type: "text" },
    { key: "pedidos", label: "Pedidos", type: "text" },
    { key: "etapa", label: "Etapa", type: "text" },
    { key: "totalAmbientes", label: "Ambientes", type: "number" },
    { key: "entregues", label: "Entregues", type: "number" },
    { key: "emAndamento", label: "Em andamento", type: "number" },
    { key: "proximaEntrega", label: "Próxima entrega", type: "date" },
    { key: "prazo", label: "Prazo", type: "text" },
    { key: "atrasoAcumulado", label: "Atraso acumulado (dias)", type: "days" },
    ...(comCentral
      ? [
          { key: "espera", label: "Quem espera", type: "text" },
          { key: "pendencias", label: "Pendências", type: "number" },
        ]
      : []),
    { key: "valor", label: "Valor", type: "currency" },
  ];
}

function linhaExportada(linha) {
  return {
    saude: linha.saude,
    faixa: ROTULO_DA_FAIXA[linha.faixa],
    nome: linha.nome,
    pedidos: linha.pedidos.join(", "),
    etapa: linha.etapa.rotulo,
    totalAmbientes: linha.totalAmbientes,
    entregues: linha.entregues,
    emAndamento: linha.emAndamento,
    proximaEntrega: linha.proximaEntrega,
    prazo: linha.prazo,
    atrasoAcumulado: linha.atrasoAcumulado,
    espera: linha.espera ? ROTULO_DA_ESPERA[linha.espera] : "",
    pendencias: linha.pendencias,
    valor: linha.valor,
  };
}

export function montarExportacao({ linhas, carteira, comCentral, paginaRef }) {
  const resumo = carteira.indicadores.map((k) => ({
    label: k.rotulo,
    value: k.valor,
    type: k.dinheiro ? "currency" : "number",
  }));
  return {
    titulo: "Clientes",
    resumo,
    secoes: [{ id: "tabela", label: "Clientes", columns: colunas(comCentral), rows: linhas.map(linhaExportada) }],
    visual: {
      ref: paginaRef,
      sections: [
        { id: "indicadores", label: "Indicadores", selector: "[data-pdf='indicadores']" },
        { id: "tabela", label: "Tabela", selector: "[data-pdf='tabela']" },
      ],
    },
  };
}
